/* src/app/components/v2-trade-request-detail-overlay/v2-trade-request-detail-overlay.component.scss */
:host {
  display: contents;
}
body.v2-trade-request-detail-open {
  overflow: hidden;
}
.v2-trade-request-detail {
  position: fixed;
  inset: 0;
  height: 100%;
  max-height: 100dvh;
  z-index: 10045;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--exme-overlay-atmosphere-background);
  --v2-trd-card-bg: rgba(255, 255, 255, 0.78);
  --v2-trd-card-border: rgba(13, 18, 24, 0.08);
  --v2-trd-card-shadow: 0 1px 2px rgba(13, 18, 24, 0.04), 0 8px 24px rgba(13, 18, 24, 0.06);
  --v2-trd-sticker-row-bg: rgba(var(--ion-color-primary-rgb), 0.06);
  --v2-trd-muted-text: var(--ion-color-text);
  --v2-trd-chrome-bg: rgba(255, 255, 255, 0.95);
  --v2-trd-sk-shimmer-base: #cfd6de;
  --v2-trd-sk-shimmer-mid: #e2e8ef;
  --v2-trd-sk-shimmer-hi: #f0f4f8;
  --v2-trd-sk-card-tint: rgba(255, 255, 255, 0.78);
  animation: v2-trd-enter 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
body.dark .v2-trade-request-detail {
  --v2-trd-card-bg: rgba(22, 28, 36, 0.75);
  --v2-trd-card-border: rgba(255, 255, 255, 0.08);
  --v2-trd-card-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
  --v2-trd-sticker-row-bg: rgba(var(--ion-color-primary-rgb), 0.14);
  --v2-trd-muted-text: var(--ion-color-text);
  --v2-trd-chrome-bg: rgba(22, 28, 36, 0.92);
  --v2-trd-sk-shimmer-base: #1f2732;
  --v2-trd-sk-shimmer-mid: #2a3442;
  --v2-trd-sk-shimmer-hi: #364353;
  --v2-trd-sk-card-tint: rgba(22, 28, 36, 0.92);
}
.v2-trade-request-detail--closing {
  pointer-events: none;
  animation: v2-trd-exit 0.4s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes v2-trd-enter {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes v2-trd-exit {
  from {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  to {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
}
.v2-trd-floating-back {
  position: fixed;
  top: max(0.65rem, env(safe-area-inset-top, 0px));
  left: 0.75rem;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  margin: 0;
  padding: 0;
  border: 1px solid var(--v2-trd-card-border);
  border-radius: 50%;
  background: var(--v2-trd-chrome-bg);
  box-shadow: var(--v2-trd-card-shadow);
  color: var(--ion-color-text);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.v2-trd-floating-back ion-icon {
  font-size: 1.35rem;
}
.v2-trd-title-pill {
  position: fixed;
  top: max(0.72rem, env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translate(-50%, -6px);
  z-index: 2;
  max-width: min(58%, 16rem);
  padding: 0.38rem 0.85rem;
  border-radius: 999px;
  background: var(--v2-trd-chrome-bg);
  border: 1px solid var(--v2-trd-card-border);
  box-shadow: var(--v2-trd-card-shadow);
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--ion-color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.35s cubic-bezier(0.22, 1, 0.36, 1), transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}
.v2-trd-title-pill--visible {
  opacity: 1;
  transform: translate(-50%, 0);
}
.v2-trd-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: calc(3.5rem + env(safe-area-inset-top, 0px)) 0.85rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.v2-trd-context {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  padding: 0.15rem 0.5rem 0.35rem;
  text-align: center;
}
.v2-trd-context__identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.42rem;
  width: 100%;
}
.v2-trd-context__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.1rem;
}
.v2-trd-avatar-btn {
  margin: 0;
  padding: 0;
  flex-shrink: 0;
}
.v2-trd-img-wrap {
  position: relative;
  display: block;
  overflow: hidden;
}
.v2-trd-img-wrap--avatar {
  width: 4.25rem;
  height: 4.25rem;
  border-radius: 50%;
}
.v2-trd-img-wrap--chip {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 10px;
}
.v2-trd-img-wrap img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.35s ease;
}
.v2-trd-img-wrap img.v2-trd-img--loaded {
  opacity: 1;
}
.v2-trd-img-wrap:has(img.v2-trd-img--loaded) .v2-trd-img-skeleton,
.v2-trd-sticker-card__img-wrap:has(img.v2-trd-img--loaded) .v2-trd-img-skeleton,
.v2-trd-sticker-img-wrap:has(img.v2-trd-img--loaded) .v2-trd-img-skeleton {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
.v2-trd-img-skeleton {
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: inherit;
  overflow: hidden;
  pointer-events: none;
  background: var(--v2-trd-sk-card-tint);
}
.v2-trd-img-skeleton::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background:
    linear-gradient(
      105deg,
      var(--v2-trd-sk-shimmer-base) 0%,
      var(--v2-trd-sk-shimmer-base) 34%,
      var(--v2-trd-sk-shimmer-mid) 44%,
      var(--v2-trd-sk-shimmer-hi) 50%,
      var(--v2-trd-sk-shimmer-mid) 56%,
      var(--v2-trd-sk-shimmer-base) 66%,
      var(--v2-trd-sk-shimmer-base) 100%);
  background-size: 240% 100%;
  animation: v2-trd-img-shimmer 1.5s ease-in-out infinite;
}
.v2-trd-img-skeleton--circle {
  border-radius: 50%;
}
.v2-trd-sticker-card__img-wrap .v2-trd-img-skeleton {
  border-radius: 10px;
}
.v2-trd-sticker-img-wrap {
  position: relative;
  flex-shrink: 0;
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 8px;
  overflow: hidden;
}
.v2-trd-sticker-img-wrap .v2-trd-img-skeleton {
  border-radius: 8px;
}
.v2-trd-sticker-img-wrap .v2-trd-sticker-img {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.35s ease;
}
.v2-trd-sticker-img-wrap .v2-trd-sticker-img.v2-trd-img--loaded {
  opacity: 1;
}
@keyframes v2-trd-img-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
.v2-trd-avatar {
  width: 4.25rem;
  height: 4.25rem;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(var(--ion-color-primary-rgb), 0.22);
}
.v2-trade-request-detail--physical .v2-trd-img-wrap--avatar,
.v2-trade-request-detail--physical .v2-trd-avatar {
  width: 5.75rem;
  height: 5.75rem;
}
.v2-trade-request-detail--physical .v2-trd-avatar {
  border-width: 2.5px;
}
.v2-trade-request-detail--physical .v2-trd-partner-name {
  font-size: 1.08rem;
}
.v2-trd-partner-name-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  max-width: 100%;
  margin-top: 0.15rem;
}
.v2-trd-partner-name {
  margin: 0;
  max-width: 100%;
  font-size: 1.02rem;
  font-weight: 700;
  color: var(--ion-color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.v2-trd-locations-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.85rem;
  height: 1.85rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.28);
  border-radius: 10px;
  background: rgba(var(--ion-color-primary-rgb), 0.12);
  color: var(--ion-color-primary);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease;
}
.v2-trd-locations-btn ion-icon {
  font-size: 1rem;
}
.v2-trd-locations-btn:active {
  transform: scale(0.92);
}
.v2-trd-date {
  margin: 0;
  font-size: 0.76rem;
  color: var(--v2-trd-muted-text);
}
.v2-trd-status {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 16px;
  border: 1px solid rgba(13, 18, 24, 0.07);
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--ion-color-text);
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
body.dark .v2-trd-status {
  background: rgba(22, 28, 36, 0.7);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.25);
}
.v2-trd-status--cancelled {
  color: var(--ion-color-red-heigh);
}
.v2-trd-status--pending {
  color: var(--ion-color-primary);
}
.v2-trd-status--accepted {
  color: var(--ion-color-success-shade, #1e8a4a);
}
.v2-trd-waiting-badge {
  flex-shrink: 0;
  margin: 0;
  padding: 0.28rem 0.55rem;
  border: none;
  border-radius: 999px;
  background: rgba(var(--ion-color-warning-rgb, 255, 196, 9), 0.18);
  color: var(--ion-color-warning-shade, #a67c00);
  font-size: 0.68rem;
  font-weight: 600;
  cursor: pointer;
}
.v2-trd-collections__label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--v2-trd-muted-text);
}
.v2-trd-collections__row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}
.v2-trd-col-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  max-width: 4.5rem;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.v2-trd-col-chip img {
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.18);
}
.v2-trd-col-chip__label {
  font-size: 0.58rem;
  font-weight: 600;
  color: var(--v2-trd-muted-text);
  text-align: center;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v2-trd-sticker-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.v2-trd-sticker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
  grid-auto-flow: dense;
  gap: 0.55rem;
}
.v2-trd-sticker-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.28rem;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  font: inherit;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.v2-trd-sticker-card--landscape {
  grid-column: span 2;
}
.v2-trd-sticker-card__img-wrap {
  position: relative;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background: var(--v2-trd-sticker-row-bg);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.v2-trd-sticker-card__img-wrap--portrait {
  aspect-ratio: 3/4;
}
.v2-trd-sticker-card__img-wrap--landscape {
  aspect-ratio: 4/3;
}
.v2-trd-sticker-card__img-wrap img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0;
  transition: opacity 0.35s ease;
}
.v2-trd-sticker-card__img-wrap img.v2-trd-img--loaded {
  opacity: 1;
}
.v2-trd-sticker-card__qty {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  padding: 0.1rem 0.32rem;
  border-radius: 999px;
  background: rgba(var(--ion-color-primary-rgb), 0.88);
  color: #fff;
  font-size: 0.58rem;
  font-weight: 700;
  line-height: 1.2;
}
.v2-trd-sticker-card__repeated {
  position: absolute;
  top: 0.12rem;
  right: 0.12rem;
  z-index: 4;
  margin: 0;
  padding: 0.12rem 0.32rem;
  border: 1px solid rgba(var(--ion-color-red-rgb), 0.32);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--ion-color-red);
  font: inherit;
  font-size: 0.52rem;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transform: rotate(-6deg);
  pointer-events: auto;
}
body.dark .v2-trd-sticker-card__repeated {
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(var(--ion-color-red-rgb), 0.42);
  color: rgba(255, 210, 210, 0.96);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-trd-sticker-card__label {
  max-width: 100%;
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--v2-trd-muted-text);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.v2-trd-sticker-card:active .v2-trd-sticker-card__img-wrap {
  transform: scale(0.97);
}
.v2-trd-empty--grid {
  grid-column: 1/-1;
}
@media (min-width: 480px) {
  .v2-trd-sticker-grid {
    grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
    gap: 0.65rem;
  }
}
.v2-trd-sticker-row {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  margin: 0;
  padding: 0.45rem 0.55rem;
  border: none;
  border-radius: 12px;
  background: var(--v2-trd-sticker-row-bg);
  text-align: left;
  font: inherit;
  color: inherit;
  cursor: pointer;
}
.v2-trd-sticker-img {
  border-radius: 8px;
  object-fit: cover;
}
.v2-trd-sticker-img--compact {
  width: 2.35rem;
  height: 2.35rem;
}
.v2-trd-qty-badge {
  flex-shrink: 0;
  padding: 0.12rem 0.38rem;
  border-radius: 999px;
  background: rgba(var(--ion-color-primary-rgb), 0.14);
  font-size: 0.62rem;
  font-weight: 700;
  color: var(--ion-color-primary);
}
.v2-trd-repeated-badge {
  flex-shrink: 0;
  margin: 0;
  padding: 0.15rem 0.4rem;
  border: 1px solid rgba(var(--ion-color-red-rgb), 0.32);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--ion-color-red);
  font: inherit;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
body.dark .v2-trd-repeated-badge {
  background: rgba(22, 28, 36, 0.92);
  border-color: rgba(var(--ion-color-red-rgb), 0.42);
  color: rgba(255, 210, 210, 0.96);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.28);
}
.v2-trd-sticker-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}
.v2-trd-sticker-name {
  font-size: 0.84rem;
  font-weight: 600;
  color: var(--ion-color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.v2-trd-sticker-id {
  font-size: 0.72rem;
  color: var(--v2-trd-muted-text);
}
.v2-trd-empty {
  margin: 0;
  padding: 0.5rem;
  font-size: 0.82rem;
  color: var(--v2-trd-muted-text);
  text-align: center;
}
.v2-trd-footer {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.45rem;
  padding: 0.75rem 0.85rem calc(0.85rem + env(safe-area-inset-bottom, 0px));
}
.v2-trd-footer--actions {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 0.55rem;
  background:
    linear-gradient(
      180deg,
      transparent 0%,
      rgba(var(--ion-color-primary-rgb), 0.04) 100%);
}
body.dark .v2-trd-footer--actions {
  background:
    linear-gradient(
      180deg,
      transparent 0%,
      rgba(0, 0, 0, 0.28) 100%);
}
.v2-trd-footer--readonly {
  background: transparent;
}
.v2-trd-footer--actions app-btn {
  flex: 1 1 calc(50% - 0.3rem);
  min-width: min(100%, 10rem);
  max-width: 14rem;
  width: auto;
}
.v2-trd-footer__history-note {
  margin: 0;
  padding: 0.35rem 0.5rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--v2-trd-muted-text);
  text-align: center;
}
.v2-trd-scrolltop {
  position: fixed;
  right: calc(0.75rem + env(safe-area-inset-right, 0px));
  bottom: max(0.85rem, env(safe-area-inset-bottom, 0px));
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-family: inherit;
  color: rgba(13, 18, 24, 0.9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: scale(1);
  transition:
    transform 0.12s ease,
    background 0.12s ease,
    opacity 0.12s ease;
  -webkit-tap-highlight-color: transparent;
}
.v2-trd-scrolltop--with-footer {
  bottom: calc(5.35rem + env(safe-area-inset-bottom, 0px));
}
.v2-trd-scrolltop__icon {
  display: block;
  width: 1.35rem;
  height: 1.35rem;
}
body.dark .v2-trd-scrolltop {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(22, 28, 36, 0.5);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}
.v2-trd-scrolltop:active {
  transform: scale(0.88);
}
body.dark .v2-trd-scrolltop:active {
  background: rgba(22, 28, 36, 0.62);
}
body:not(.dark) .v2-trd-scrolltop:active {
  background: rgba(255, 255, 255, 0.68);
}
.v2-trd-scrolltop:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.55);
  outline-offset: 2px;
}
body.dark .v2-trd-scrolltop:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
  outline-offset: 2px;
}
@media (prefers-reduced-motion: reduce) {
  .v2-trd-scrolltop {
    transition: none;
  }
  .v2-trd-scrolltop:active {
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2-trade-request-detail,
  .v2-trade-request-detail--closing {
    animation: none;
  }
  .v2-trd-img-skeleton::after {
    animation: none;
    background: var(--v2-trd-sk-shimmer-mid);
    background-size: 100% 100%;
  }
  .v2-trd-img-wrap img,
  .v2-trd-sticker-card__img-wrap img,
  .v2-trd-sticker-img-wrap .v2-trd-sticker-img {
    transition: none;
  }
}
/*# sourceMappingURL=v2-trade-request-detail-overlay.component.css.map */
